import Cookies from "js-cookie";
import Util from "./Util";

const domain = (() => {
  let hostname;
  if (typeof window === "undefined") {
    //server side
    hostname = Util.getOrigin("www",{noProtocol:true});
  } else {
    hostname = location.hostname;
  }
    return hostname.split(".").slice(-2).join(".");
})();

const keyList = {
  lang: "lang", //存储语言信息
  langManual: "langManual", //是否手动切换过语言
  theme: "theme", //主题信息
  token: "token", //token
  clientCode: "clientCode", //设备唯一code
  currency: "currency", //货币类型，譬如 usd
  countryId: "countryId",   //国家ID
};

export default {
  keyList,
  get(key, opt) {
    const itemKey = keyList[key];
    if (!itemKey)
      return console.log(
        "%c$cookie.get 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    return Cookies.get(itemKey, {
      domain,
      ...(opt || {}),
    });
  },
  set(key, value, opt) {
    const itemKey = keyList[key];
    if (!itemKey)
      return console.log(
        "%c$cookie.set 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    return Cookies.set(itemKey, value, {
      expires: 30,
      domain,
      ...(opt || {}),
    });
  }, //对象会被压成字符串
  remove(key, opt) {
    const itemKey = keyList[key];
    if (!itemKey)
      return console.log(
        "%c$cookie.remove 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );
    Cookies.remove(itemKey, {
      ...(opt || {}),
    });
    return Cookies.remove(itemKey, {
      domain,
      ...(opt || {}),
    });
  },
};
